import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
            prop: 'first_name',
            label: i18n.t('common_words.name'),
            minWidth: 130,
            align: 'left',
            sortable: true,
            formatter: (row) => {
                return `${row.first_name}  ${row.last_name}`
            },
        },
        {
            prop: 'email',
            label: i18n.t('common_words.email'),
            minWidth: 150,
            align: 'left',
            sortable: true,
        },
        {
            prop: 'total_session_human',
            label: i18n.t('audit.total_time_in_system'),
            minWidth: 100,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'sessions_count',
            label: i18n.t('audit.total_active_sessions'),
            minWidth: 80,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'total_logins',
            label: i18n.t('audit.total_logins'),
            minWidth: 80,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'total_logouts',
            label: i18n.t('audit.total_logouts'),
            minWidth: 80,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'total_failed',
            label: i18n.t('audit.total_failed_logins'),
            minWidth: 80,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'first_activity',
            label: i18n.t('audit.first_login_date'),
            minWidth: 100,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'last_activity',
            label: i18n.t('audit.logout_date'),
            minWidth: 100,
            align: 'center',
            sortable: true,
        },
    ];
    const Search = { ...Tables.Search };

    return { Table, Search };
}
export default configTable;